import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import type { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Auth0Store } from '../store';
import { LoginGuard } from './login.guard';

import { RootRouteStore } from '../../../store';

@Injectable({
  providedIn: 'root',
})
export class SIGGuard {
  private loginGuard = inject(LoginGuard);
  private auth0Store = inject(Auth0Store);
  private router = inject(Router);
  private routeStore = inject(RootRouteStore);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return (this.loginGuard.canActivate(route, state) as Observable<boolean>).pipe(
      map((loggedIn) => {
        const userSigs = this.auth0Store.userSigs();
        const params = this.routeStore.params();
        const value = loggedIn ? userSigs?.includes(params.sigId) : false;
        if (!value) {
          this.router.navigate(['/clinical-db']);
        }

        return value;
      }),
      take(1),
    );
  }
}
